const uppercaseFirst = function(str){
  return str.charAt(0).toUpperCase() + str.slice(1)
}

const date2Str = function(datetime){
  let Y = datetime.getFullYear()
  let M = (datetime.getMonth()+1 < 10 ? '0'+(datetime.getMonth()+1) : datetime.getMonth()+1)
  let D = (datetime.getDate() < 10 ? '0'+(datetime.getDate()) : datetime.getDate())
  let h = (datetime.getHours() < 10 ? '0'+(datetime.getHours()) : datetime.getHours())
  let m = (datetime.getMinutes() < 10 ? '0'+(datetime.getMinutes()) : datetime.getMinutes())
  let s = (datetime.getSeconds() < 10 ? '0'+(datetime.getSeconds()) : datetime.getSeconds())
  return `${Y}-${M}-${D} ${h}:${m}:${s}`
}

export {
  uppercaseFirst,
  date2Str
}